import { PercentPipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

const DEFAULT_DIGITS_INFO = '1.0-2';

@Pipe({
  name: 'aapercent',
  standalone: false,
})
export class AaPercentPipe extends PercentPipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) locale: string) {
    super(locale);
  }

  transform(value: any, digitsInfo?: string): any {
    return super.transform(value, digitsInfo || DEFAULT_DIGITS_INFO);
  }
}
